
// 주문 관련 api는 성공/실패 id를 보내주므로 이걸로 화면 처리용 메시지를 생성
export const getResultMsg = (resultData) => {
	const successList = resultData.successProductOrderIds;
	const failList = resultData.failProductOrderInfos;
	let msg = "";
	if(successList.length > 0 && failList.length === 0) {
		// 전체 성공인 경우
		return null;
	}

	if(successList.length > 0) {
		msg += successList.length > 0 ? "성공 : " + successList.length  + "건" : "";
		msg += "[성공]";
		const successMgt = successList.map((d) => {
			// return "\n" + d.productOrderId;
			return "\n" + d;
		});
		msg += successMgt;
	}

	if(failList.length > 0) {
		if(successList.length > 0)  msg += "\n\n";
		msg += "[실패]";
		const failMsg = failList.map((d) => {
			return "\n" + d.productOrderId + " : " + d.message;
		});
		msg += failMsg;
	}
	return msg;
}